// extracted by css-extract-rspack-plugin
export default {"rxIcon":"rxIcon-X7Py4i","rxHeaderIconAdjust":"rxHeaderIconAdjust-yvqOf8"};